import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./drhf.scss"
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ButtonsContainer from 'components/buttons/buttonsContainer'
export default function Drhf() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Ma DRHF",
            icon : "drhf.svg",
            color : "bckGreen"
        })
    }, [])
    const buttons = [
        {
            title : "Trombinoscope",
            icon : "picto_trombinoscope.svg",
            buttonBackground : "bckGreen80",
            page : "/accueil/drhf/trombi_drhf",
            right : "600px",
            delay : "0"
        },
        {
            title : "Actus intranet",
            icon : "picto_actu_intranet.svg",
            buttonBackground : "bckGreen80",
            page : "/accueil/drhf/actus_intranet",
            left : "600px",
            delay : "0"
        },
        {
            title : "Fiche contact",
            icon : "picto_fiche_contact.svg",
            buttonBackground : "bckGreen80",
            page : "/accueil/drhf/fiche_contact",
            right : "600px",
            delay : "200"
        },
        {
            title : "Capsules ANFH",
            icon : "picto_capsule_anfh.svg",
            buttonBackground : "bckGreen80",
            page : "/accueil/drhf/capsule_anfh",
            left : "600px",
            delay : "200"
        },
    ]
    return (
        <div className="w100 h100 page" id="drhf">
            <div className='w100' style={{padding : "100px"}}>
                <ButtonsContainer buttons={buttons}/>
            </div>        
        </div>
    )
}
